export const SearchFormExportsComponent = {
  templateUrl:
    './app/ajs/_shared/components/search-form-exports/search-form-exports.component.html',
  bindings: {
    urlXls: '<',
    urlPdf: '<',
    reportName: '<',
    filterCriteria: '<',
  },
  controller: SearchFormExportsController,
  controllerAs: 'vm',
};

SearchFormExportsController.$inject = [
  'UtilService',
  'Blob',
  'moment',
  'TransactionReportService',
  'FileSaver',
];

function SearchFormExportsController(
  UtilService,
  Blob,
  moment,
  TransactionReportService,
  FileSaver
) {
  const vm = this;

  // private properties
  // -----------------------
  vm.UtilService = new UtilService(vm);
  const timeZone = moment().format('Z'); // !important to display the correct date in the reports

  // public methods
  // -----------------------
  vm.downloadReportXLS = function () {
    vm.filterCriteria.time_zone = timeZone;

    vm.loadingDownload = true;
    TransactionReportService.downloadReportXLS(vm.filterCriteria, vm.urlXls).then(function (data) {
      let fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      let blobVar = new Blob([vm.UtilService.s2ab(data)], { type: fileType });

      FileSaver.saveAs(blobVar, vm.reportName + '.xlsx'); // TODO: willy -fix this

      vm.loadingDownload = false;
    });
  };

  vm.downloadReportPDF = function () {
    vm.filterCriteria.time_zone = timeZone;

    vm.loadingDownload = true;
    TransactionReportService.downloadReportPDF(vm.filterCriteria, vm.urlPdf).then(function (data) {
      let fileType = 'application/pdf';
      let blobVar = new Blob([data], { type: fileType });

      FileSaver.saveAs(blobVar, vm.reportName + '.pdf'); // TODO: willy -fix this

      vm.loadingDownload = false;
    });
  };
}
